import {registerTranslateConfig, Strings} from "lit-translate";
import merge from 'lodash.merge';
import {container} from "tsyringe";
import {UserRepository} from "./domain/repositories/user.repository";
import "urlpattern-polyfill";
import {DynamicLoadService} from "./dynamic-loading/dynamic-load.service";
import {LINKVIEW_REPOSITORY} from "./domain/repositories/abstract-linkview.repository";
import {BackendLinkviewRepository} from "./domain/repositories/backend-linkview.repository";

registerTranslateConfig({
    loader: async (language): Promise<Strings> => {
        const languageContexts = language.split('.').reduce((accumulator: string[], current: string, index: number) => {
            accumulator.push((accumulator[index - 1] ? accumulator[index - 1] + '.' : '') + current);
            return accumulator;
        }, []);

        const strings: Strings[] = await Promise.all(languageContexts.map(async language => {
            return await fetch(`/assets/i18n/${language}.json`)
                .then(res => res.json())
                .catch(() => ({}));
        }));

        return Promise.resolve(merge({}, ...strings));
    }
});

container.registerSingleton(UserRepository);
container.register<UserRepository>("UserRepository", {useToken: UserRepository});
container.register<DynamicLoadService>("DynamicLoadService", {useToken: DynamicLoadService});
container.registerSingleton(LINKVIEW_REPOSITORY, BackendLinkviewRepository);